import { z } from 'zod';
import { zNoticeType, zPlatform } from './enums';
import { zText } from './primitives';

/**
 * Platform-level notices managed by OrderHub operators (not restaurant owners).
 * Used for app update prompts, scheduled maintenance alerts, outage notifications,
 * and other platform-wide announcements. Can target specific apps, versions, and platforms.
 */
export const noticeSchema = z.object({
  expireAt: z.string().nullable().default(null),
  isAppStoreLinkVisible: z.boolean().default(false),
  isDismissible: z.boolean().default(true),
  noticeText: z.string(),
  noticeType: zNoticeType.default('BANNER'),
  targetAppJsVersion: z.string().nullable().default(null),
  targetAppNativeVersion: z.string().nullable().default(null),
  targetAppPlatforms: z.array(zPlatform).default([]),
  targetRestaurantUuid: z.string().nullable().default(null), // Link to Convex restaurant id?

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type Notice = z.output<typeof noticeSchema>;

// Extra validations
export const noticeStrictSchema = noticeSchema.safeExtend({
  noticeText: zText,
  targetRestaurantUuid: z.guid().nullable(),
});

// Convex stored shape (with validations, so when data is pulled out it passed through this validation)
// Not sure if this is good, or if i should extend noticeShape instead?
export const noticeCvxSchema = noticeSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type NoticeCvx = z.output<typeof noticeCvxSchema>;
